if (!customElements.get('collection-hero-tiles-slider')) {
  customElements.define(
    'collection-hero-tiles-slider',
    class CollectionHeroTilesSlider extends HTMLElement {
      connectedCallback() {
        if (typeof Swiper === 'undefined') return;

        // Below 1150px the tiles become a swipeable carousel; above it they stay a single row.
        this.mediaQuery = window.matchMedia('(max-width: 1149px)');
        this.onMediaChange = this.toggle.bind(this);
        this.mediaQuery.addEventListener('change', this.onMediaChange);
        this.toggle();
      }

      disconnectedCallback() {
        this.mediaQuery?.removeEventListener('change', this.onMediaChange);
        this.destroySwiper();
      }

      toggle() {
        if (this.mediaQuery.matches) {
          this.initSwiper();
        } else {
          this.destroySwiper();
        }
      }

      initSwiper() {
        if (this.swiper) return;

        this.swiper = new Swiper(this, {
          // Theme class names, so swiper-bundle.min.css isn't needed and the desktop row is untouched.
          wrapperClass: 'collection-hero-tiles__grid',
          slideClass: 'collection-tiles__item',
          slidesPerView: 2.2,
          spaceBetween: 16,
          watchOverflow: true,
          grabCursor: true,
          breakpoints: {
            750: { slidesPerView: 3.3, spaceBetween: 20 },
          },
        });
      }

      destroySwiper() {
        if (!this.swiper) return;
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  );
}
